/**
 * validateEmail -function to validate email address
 * @param email email address to validate
 * @returns true if email is valid, false otherwise
 */

export function validateEmail(email: string) {
    return email.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)
}
